import { render } from "./list-share-users-search.vue?vue&type=template&id=1b6df043&scoped=true&ts=true"
import script from "./list-share-users-search.vue?vue&type=script&lang=ts"
export * from "./list-share-users-search.vue?vue&type=script&lang=ts"

import "./list-share-users-search.vue?vue&type=style&index=0&id=1b6df043&lang=scss&scoped=true"
import "./list-share-users-search.vue?vue&type=style&index=1&id=1b6df043&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6df043"]])

export default __exports__